import { FocusEvent, KeyboardEvent, MouseEvent } from 'react';
type FocusOptionsWithVisible = FocusOptions & {
  focusVisible?: boolean;
};
export const focusWithoutVisibleRing = (element: HTMLElement | null | undefined) => {
  if (!element) return;
  element.dataset.pointerFocus = 'true';
  const focusOptions: FocusOptionsWithVisible = {
    focusVisible: false
  };
  element.focus(focusOptions as FocusOptions);
};
export const handlePointerInputFocus = (event: MouseEvent<HTMLInputElement>) => {
  event.preventDefault();
  focusWithoutVisibleRing(event.currentTarget);
};
export const handleKeyboardInputFocus = (event: KeyboardEvent<HTMLInputElement>) => {
  if (event.key === 'Tab') {
    delete event.currentTarget.dataset.pointerFocus;
  }
};
export const clearPointerInputFocus = (event: FocusEvent<HTMLInputElement>) => {
  delete event.currentTarget.dataset.pointerFocus;
};